<template>
  <div class="step-outer-box">
    <div class="bottom-all-box" id="questionBox">
      <div class="intro-line">
        <div class="intro-line-left">任务说明</div>
        <div class="intro-line-right">
          {{ task_description }}
        </div>
      </div>

      <div v-if="course_questions && course_questions.length > 0" class="question-box">
        <!-- single 单选  multiple 多选 judge 判断 right 答对的状态 -->
        <div :id="`targetQues${item.id}`" :class="['ques-items',(item.type == 1 ? 'single' : item.type == 2 ? 'multiple' : 'judge'),(item.answer_status == 1 ? 'right' : item.answer_status == 2 ? 'error' : '')]"
          v-for="(item, index) in course_questions" :key="`p${index}`">
          <div class="ques-body">
            <div v-if="index < 9" class="label-line">0{{ index + 1 }}</div>
            <div v-else class="label-line">{{ index + 1 }}</div>
            <div class="body-text">
              <span>【{{item.type == 1 ? "单选题": item.type == 2? "多选题" : "判断题"}}】</span>
              <span v-html="item.content"></span>
            </div>
          </div>

          <div v-if="(item.type == 1 || item.type == 2) && item.course_question_details" class="ques-options">
            <div v-for="(sub, sinx) in item.course_question_details" :key="`sub${sinx}`" @click="chooseQuestion(index, sinx, item.type)" :class="['opt-item', sub.is_checked ? 'checked' : '']">
              <div class="opt-icon"></div>
              {{ String.fromCharCode(sinx + 65) }}：<span v-html="sub.content"></span>
            </div>
          </div>

          <div v-if="is_sub == 2 &&item.type == 3" class="judge-list">
            <div :class="['judge-item', item.checked == 1 ? 'checked' : '']" @click="changeJudge(index, 1)">
              对
            </div>
            <div :class="['judge-item', item.checked == 2 ? 'checked' : '']" @click="changeJudge(index, 2)">
              错
            </div>
          </div>

          <div v-if="is_sub == 1" class="answer-line">
            <div class="answer-icon"></div>
            <!-- 判断题 答案回显 -->
            <template v-if="item.type == 3">
              <div class="answer-item">
                正确答案：<template v-for="(answer) in item.course_question_details">{{answer.is_right == 1 ?"对":answer.is_right == 2?"错": ''}}</template>
              </div>
              <div class="answer-item">你的答案：{{item.answer == 1 ? "对":item.answer == 2?"错":''}}</div>
            </template>
            <template v-else>
              <!-- 单选和多选 答案回显 -->
              <div class="answer-item">
                正确答案：<template v-for="(answer, aindex) in item.course_question_details">
                  <template v-if="answer.is_right == 1">
                    {{String.fromCharCode(aindex + 65)}}
                  </template>
                </template>
              </div>
              <div class="answer-item">你的答案：<template v-for="(answer, aindex) in item.course_question_details">
                  <template v-if="answer.is_checked">
                    {{String.fromCharCode(aindex + 65)}}
                  </template>
                </template></div>
            </template>
          </div>
        </div>
      </div>

      <div v-if="is_sub == 2" class="submit-box">
        <div class="submit-btn" @click="submitQuestion">提交作业</div>
      </div>
    </div>

    <CommonModal v-model="showModal" title="提示" confirmText="确定" @confirm="handleConfirm">
      <div class="delete-modal">
        有未作答试题，无法提交。
      </div>
    </CommonModal>

    <CommonModal v-model="showSubmitModal" title="提示" confirmText="确定" @confirm="handleSubmitConfirm">
      <div class="delete-modal">
        确认提交吗？提交后无法修改答案。
      </div>
    </CommonModal>

  </div>
</template>

<script>
import services from "../../../../assets/js/services";
import CommonModal from "../../../../components/CommonModal"
export default {
  name: "unitOne",
  components: {
    CommonModal
  },
  data () {
    return {
      services,
      task_description: "", //任务说明
      is_sub: 2, // 是否提交过 1是2否
      course_questions: null, // 答题
      activity_id: "",
      course_id: "",
      chapter_id: "",
      showModal: false,
      showSubmitModal: false,
      notansweredId: '',
      answer: null,
      is_request: false, // 是否已经有提交的请求
    };
  },
  created () { },
  mounted () {
    let query = this.$route.query;
    this.activity_id = query.activity_id;
    this.course_id = query.course_id;
    this.chapter_id = query.chapter_id;
    this.getTaskData();
  },
  methods: {
    async getTaskData () {
      let result = await services.getCenterTaskData({
        code: "t004",
        activity_id: this.activity_id,
        course_id: this.course_id,
        chapter_id: this.chapter_id,
      });
      if (result.code == "0000" && result.data) {
        this.task_description = result.data.task_description;
        this.is_sub = result.data.is_sub;
        let questions = result.data.course_questions;

        for (let i = 0; i < questions.length; i++) {
          if (
            (questions[i].type == 1 || questions[i].type == 2) &&
            questions[i].course_question_details.length > 0
          ) {
            let answer = questions[i].answer ? questions[i].answer.split(",") : [];
            let arr = questions[i].course_question_details.map((item) => {
              if (result.data.is_sub == 1) {
                if (answer.indexOf(item.id + '') > -1) {
                  item.is_checked = true;
                }
              } else {
                item.is_checked = false;
              }
              return item;
            });
            questions[i].course_question_details = arr;
          }
        }
        this.course_questions = questions;
      }
    },
    // 选择题 选项点击事件
    chooseQuestion (index, sinx, type) {
      if (this.is_sub == 1) {
        return;
      }
      let ques = this.course_questions[index].course_question_details;
      ques &&
        ques.forEach((element, inx) => {
          if (type == 1) {
            // 单选
            if (inx == sinx) {
              element.is_checked = true;
            } else {
              element.is_checked = false;
            }
          } else if (type == 2) {
            // 多选
            if (inx == sinx) {
              element.is_checked = element.is_checked ? false : true;
            }
          }
        });
      this.$set(this.course_questions[index], "course_question_details", ques);
    },
    // 判断题 点击事件
    changeJudge (index, val) {
      this.$set(this.course_questions[index], "checked", val);
    },
    // 提交作业
    submitQuestion () {
      this.notansweredId = ''
      let questions = this.course_questions;
      let notanswered = false; // 是否有未作答
      let notansweredId = ''; // 未作答的题目id
      let answer = {};
      for (let i = 0; i < questions.length; i++) {
        if (questions[i].type == 3) {
          // 判断题
          if (questions[i].checked) {
            answer[questions[i].id] = questions[i].checked;
          } else {
            notanswered = true;
            notansweredId = questions[i].id;
            break;
          }
        } else {
          // 单选和多选
          let arr = [];
          for (let s = 0; s < questions[i].course_question_details.length; s++) {
            let sub = questions[i].course_question_details[s];
            if (sub.is_checked) {
              arr.push(sub.id);
            }
          }
          if (arr.length == 0) {
            notanswered = true;
            notansweredId = questions[i].id;
            break
          }
          answer[questions[i].id] = arr.join(",");
        }
      }

      if (notanswered) {
        console.log(notansweredId)
        this.notansweredId = notansweredId
        this.showModal = true
        return false
      } else {
        this.answer = answer
        this.showSubmitModal = true

      }
    },
    submitAnswer () {
      if (this.is_request) {
        return false
      }
      this.is_request = true
      services.sutmitT004({
        activity_id: this.activity_id,
        course_id: this.course_id,
        answer: JSON.stringify(this.answer),
      }).then(result => {
        this.is_request = false
        if (result.code == "0000") {
          this.$message.success("提交成功");
          this.answer = null
          this.showSubmitModal = false
          this.getTaskData()
        } else {
          this.$message.error(result.message)
        }
      }).catch(err => {
        this.is_request = false
        console.log(err)
      })
    },
    // 元素滚动到指定位置
    scrollToElement (name) {
      let that = this
      // 计算目标元素的顶部位置
      var targetPosition = that.$(`#${name}`).offset().top - that.$("#questionBox").offset().top + that.$("#questionBox").scrollTop();
      that.$("#questionBox").animate({
        scrollTop: targetPosition
      }, 200);
    },
    handleConfirm () {
      let that = this
      this.showModal = false
      this.$nextTick(() => {
        that.scrollToElement(`targetQues${that.notansweredId}`)
      })
    },
    handleSubmitConfirm () {
      this.submitAnswer()
    }
  },
};
</script>

<style lang="less" scoped>
.step-outer-box {
    width: 100%;
    background: #ffffff;
    .bottom-all-box {
        border: 1px solid #e7eaec;
        padding: 18px 25px 0;
        position: relative;
        overflow-y: auto;
        height: calc(100vh - 150px);
        min-height: 700px;
        .submit-box {
            width: 100%;
            position: sticky;
            bottom: 0;
            left: 0;
            z-index: 10;
            padding: 20px 25px;
            text-align: center;
            border-top: 1px solid #ebedef;
            background: #ffffff;
            box-sizing: border-box;
            .submit-btn {
                cursor: pointer;
                margin: 0 auto;
                width: 88px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #a82822;
                font-size: 14px;
                color: #ffffff;
            }
        }
    }
    .intro-line {
        display: flex;
        margin-bottom: 6px;
        .intro-line-left {
            width: 86px;
            height: 30px;
            background: #bc7a6e;
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            line-height: 30px;
            border-radius: 14px 0px 0px 14px;
            font-weight: bold;
        }
        .intro-line-right {
            flex: 1;
            max-height: 120px;
            overflow-y: auto;
            background: #fcf2f0;
            line-height: 20px;
            border-radius: 4px;
            font-size: 14px;
            color: #2f2626;
            min-height: 30px;
            padding: 5px 15px;
            &.last-line {
                background: #fff3f2;
                font-size: 14px;
                color: #2f2626;
            }
        }
    }
    .question-box {
        padding: 0 0 30px;
        .ques-items {
            padding: 20px 0 10px;
            border-bottom: 1px solid #eef1f3;
            &:last-child {
                border-bottom: none;
            }
            & > div {
                padding-left: 15px;
                padding-right: 15px;
            }
            .ques-body {
                font-weight: 400;
                display: flex;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 15px;
                .label-line {
                    color: #a82822;
                    display: inline-block;
                    margin-right: 4px;
                }
                .body-text {
                    color: #302e2f;
                    display: inline-block;
                    span {
                        color: #a82822;
                        display: inline;
                    }
                    /deep/ p {
                        display: inline !important;
                    }
                }
            }
            .ques-options {
                .opt-item {
                    font-size: 14px;
                    color: #777b85;
                    margin-bottom: 10px;
                    cursor: pointer;
                    .opt-icon {
                        display: inline-block;
                        margin-right: 10px;
                        width: 14px;
                        height: 14px;
                        background: url('../../../../assets/image/student/stepFour/unitOne/radio.png')
                            no-repeat center;
                        background-size: cover;
                        vertical-align: -2px;
                    }
                    &:hover {
                        color: #cd6b06;
                    }
                    /deep/ p {
                        display: inline !important;
                    }
                }
            }
            &.single {
                .opt-item .opt-icon {
                    background: url('../../../../assets/image/student/stepFour/unitOne/radio.png')
                        no-repeat center;
                    background-size: cover;
                }
                .opt-item.checked .opt-icon {
                    background: url('../../../../assets/image/student/stepFour/unitOne/radio-active.png')
                        no-repeat center;
                    background-size: cover;
                }
            }
            &.multiple {
                .opt-item .opt-icon {
                    background: url('../../../../assets/image/student/stepFour/unitOne/checkbox.png')
                        no-repeat center;
                    background-size: cover;
                }
                .opt-item.checked .opt-icon {
                    background: url('../../../../assets/image/student/stepFour/unitOne/checkbox-active.png')
                        no-repeat center;
                    background-size: cover;
                }
            }
            .judge-list {
                display: block;
                margin-bottom: 10px;
                .judge-item {
                    cursor: pointer;
                    display: inline-block;
                    margin-right: 24px;
                    width: 140px;
                    height: 30px;
                    line-height: 28px;
                    text-align: center;
                    background: #ffffff;
                    border-radius: 15px;
                    border: 1px solid #d8dbe1;
                    font-size: 14px;
                    color: #777b85;
                    &:hover,
                    &.checked {
                        color: #cd6b06;
                        background: #fff6ed;
                        border: 1px solid #d7b9a4;
                    }
                    &::before {
                        content: '';
                        display: inline-block;
                        margin-right: 10px;
                        width: 14px;
                        height: 14px;
                        background: url('../../../../assets/image/student/stepFour/unitOne/radio.png')
                            no-repeat center;
                        background-size: cover;
                        vertical-align: -2px;
                    }
                    &.checked::before {
                        background: url('../../../../assets/image/student/stepFour/unitOne/radio-active.png')
                            no-repeat center;
                        background-size: cover;
                    }
                }
            }
            .answer-line {
                padding-top: 5px;
                padding-bottom: 5px;
                .answer-icon {
                    width: 17px;
                    height: 17px;
                    display: inline-block;
                    margin-right: 12px;
                    background: url('../../../../assets/image/student/stepFour/unitOne/right.png')
                        no-repeat center;
                    background-size: cover;
                    vertical-align: -3px;
                }
                .answer-item {
                    display: inline-block;
                    font-weight: 400;
                    font-size: 14px;
                    color: #91959f;
                    margin-right: 30px;
                }
            }
            &.right {
                .answer-line {
                    background-color: #ecfbf7;
                }
                .answer-icon {
                    background: url('../../../../assets/image/student/stepFour/unitOne/right.png')
                        no-repeat center;
                    background-size: cover;
                }
            }
            &.error {
                .answer-line {
                    background-color: #fff8f8;
                }
                .answer-icon {
                    background: url('../../../../assets/image/student/stepFour/unitOne/error.png')
                        no-repeat center;
                    background-size: cover;
                }
            }
        }
    }
}
</style>